// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { PageLayout } from "#/features/global-ui/page-layout"
import { Title } from "#/services/page-title/Title"
import { Paths } from "#/utils/Paths"
import { BookingFlow } from "@internal/telemedicine"
import { useFlags } from "launchdarkly-react-client-sdk"
import React from "react"
import { Redirect, useHistory, useLocation } from "react-router-dom"

// The Slice 1 telemedicine programs. The flow targets one program at a time.
const TELEMEDICINE_PROGRAMS = ["fertility", "menopause", "mens_health"] as const
type TelemedicineProgram = typeof TELEMEDICINE_PROGRAMS[number]
const DEFAULT_PROGRAM: TelemedicineProgram = "fertility"

// The program comes from the entry point as a `?program=` query param (e.g. a per-program
// provider-finder landing page deep-links in). Falls back to the default when absent or
// unrecognized. Wiring the entry points to always set it is a follow-up (OPS-9280).
function useProgramParam(): TelemedicineProgram {
  const { search } = useLocation()
  const raw = new URLSearchParams(search).get("program") ?? ""
  return (TELEMEDICINE_PROGRAMS as readonly string[]).includes(raw) ? (raw as TelemedicineProgram) : DEFAULT_PROGRAM
}

export function TelemedicineBookingPage() {
  const { telemedicineBookingFlow } = useFlags()
  const history = useHistory()
  const program = useProgramParam()

  if (!telemedicineBookingFlow) {
    return <Redirect to={Paths.HOME} />
  }

  return (
    <PageLayout variant="default">
      <Title title="Telemedicine Booking" />
      <BookingFlow
        program={program}
        onExit={() => history.push(Paths.HOME)}
        onReturnToProviderResults={() => history.push(Paths.PROVIDER_FINDER)}
      />
    </PageLayout>
  )
}
